import { FC, useRef, useState } from 'react';
import Webcam from 'react-webcam';
import { base64ToFile } from '@/helpers/utils';
import IcoCameraFacingMode from '@/assets/svg/ico_camera_facing_mode.svg?react';
import Button from '@/components/controls/Button/Button.component';
import ModalSheet from '@/components/interactive/ModalSheet/ModalSheet.component';
import styles from '@/components/interactive/WebCamSourceBlock/WebCamModal/WebCamModal.module.scss';
import {
    FacingModeT,
    WebCamModalPropsIF,
} from '@/components/interactive/WebCamSourceBlock/WebCamModal/WebCamModal.types';

const WebCamModal: FC<WebCamModalPropsIF> = ({ addFiles, onClose }) => {
    const webcamRef = useRef<Webcam | null>(null);

    const [facingMode, setFacingMode] = useState<FacingModeT>('environment');

    const toggleCamera = (): void => {
        setFacingMode((mode) => (mode === 'user' ? 'environment' : 'user'));
    };

    const takePhoto = (): void => {
        const screenshot = webcamRef.current?.getScreenshot();

        if (!screenshot) {
            return;
        }

        const file = base64ToFile(screenshot, `webcam-${Date.now()}.jpg`);
        addFiles([file]);
        onClose();
    };

    return (
        <ModalSheet
            dataTest="web_cam_modal"
            classNameWrapper={styles.modalWrapper}
            classNameBody={`flcol ${styles.modalBody}`}
            custom
            onClose={onClose}
        >
            <Webcam
                ref={webcamRef}
                audio={false}
                width="100%"
                height="100%"
                screenshotFormat="image/jpeg"
                videoConstraints={{
                    height: 1280,
                    facingMode,
                }}
            />

            <div className={styles.label}>Photo</div>

            <div className={styles.webCamMenu}>
                <Button
                    clickHandler={onClose}
                    dataTest="web_cam_cancel_button"
                    className={`flc ${styles.cancel}`}
                    isCustom
                >
                    Отмена
                </Button>
                <Button
                    clickHandler={takePhoto}
                    dataTest="web_cam_source_get_photo_button"
                    className={styles.getPhotoButton}
                    isCustom
                />
                <Button
                    clickHandler={toggleCamera}
                    dataTest="web_cam_facing_mode_button"
                    className={`flc ${styles.facingMode}`}
                    isCustom
                >
                    <IcoCameraFacingMode />
                </Button>
            </div>
        </ModalSheet>
    );
};

export default WebCamModal;
